import React from 'react';
import VoteContainer from './components/VoteContainer';

function App() {
  return <VoteContainer />;
}

export default App;
